import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import checkImg from "../assets/icons/check_circle.png";

import {
  CREATE_EVENT_TYPE_MUTATION,
  EDIT_EVENT_TYPE_MUTATION,
} from "../graphQL/event_type_qry";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function ManageEventTypeInputsDialog({
  title,
  index,
  text,
  values, // values to update fields
  data, // event type data
  contentMsg,
  type,
  closeDialog,
  addEditDialog,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState([]);
  const [textFieldValue, setTextFieldValue] = useState(values ? values : []);

  // const tenantId = localStorage.getItem("tenantId");
  const clientId = localStorage.getItem("clientId");

  const [createEventType] = useMutation(CREATE_EVENT_TYPE_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const [editEventType] = useMutation(EDIT_EVENT_TYPE_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleDone = textFieldValue => {
    // Validate event name

    if (!textFieldValue[0] || textFieldValue[0].trim() === "") {
      setErrorMsg("This is a required field");
      return;
    }
    // Control that the name of the event is not repeated
    if (
      (values && values[0].toLowerCase() !== textFieldValue[0].toLowerCase()) ||
      !values
    ) {
      const findEventTypeIndex = data.findIndex(
        item => item.name.toLowerCase() === textFieldValue[0].toLowerCase()
      );
      if (findEventTypeIndex !== -1) {
        setErrorMsg("This name already exists");
        return;
      }
    }

    let desc = null;
    if (textFieldValue[1] && textFieldValue[1].trim() !== "") {
      desc = textFieldValue[1];
    }
    //save to database
    if (type == "Add") {
      const { eventTypeData, error } = createEventType({
        variables: {
          name: textFieldValue[0],
          clientId: parseInt(clientId),
          desc: desc,
        },
      });
      if (error) {
        console.log("Error", error, eventTypeData);
        setErrorMsg("Unfortunately an error occurred.");
      } else if (eventTypeData && eventTypeData.createEventType) {
        console.log("Success", eventTypeData);
      }
    } else if (type == "Edit") {
      const { eventTypeData, error } = editEventType({
        variables: {
          name: textFieldValue[0],
          eventTypeId: parseInt(index),
          desc: desc,
        },
      });
      if (error) {
        console.log("Error", error, eventTypeData);
        setErrorMsg("Unfortunately an error occurred.");
      } else if (eventTypeData && eventTypeData.editEventType) {
        console.log("Success", eventTypeData);
      }
    }

    setOpen(false);
    addEditDialog && addEditDialog(textFieldValue);
  };

  const handleTextFieldChange = (event, index) => {
    const newInputs = [...textFieldValue];
    newInputs[index] = event.target.value;
    setTextFieldValue(newInputs);
    if (index === 0 && event.target.value.trim() !== "") setErrorMsg("");
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            {title}
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h3" style={{ fontSize: 16, paddingBottom: 10 }}>
            {text}
          </Typography>
          {contentMsg.map((cntMsg, index) => (
            <DialogContentText id="alert-dialog-description">
              <TextField
                //className={classes.textFieldStyle}
                fullWidth
                autoFocus={index == 0}
                label={cntMsg}
                margin="normal"
                name="name"
                variant="outlined"
                id="name"
                value={textFieldValue[index]}
                onChange={e => {
                  handleTextFieldChange(e, index);
                }}
                onKeyDown={e => {
                  e.key === "Enter" && handleDone(textFieldValue);
                }}
              />
              {errorMsg && index === 0 && (
                <Box ml={2}>
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg}
                  </FormHelperText>
                </Box>
              )}
            </DialogContentText>
          ))}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={() => handleDone(textFieldValue)}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
